import React, { useEffect, useState } from 'react';
import { Card, Form, Button, ListGroup } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';

const FreelancersTab = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [cvPreviewUrl, setCvPreviewUrl] = useState(null);
  const [freelancers, setFreelancers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [skills, setSkills] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState('All');
  const [selectedFreelancer, setSelectedFreelancer] = useState(null);

  useEffect(() => {
    fetchFreelancers();
  }, []);

  const fetchFreelancers = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/freelancers`);
      const data = await res.json();
      setFreelancers(data);
      setFiltered(data);

      const skillSet = new Set();
      data.forEach(f => {
        if (Array.isArray(f.skills)) {
          f.skills.forEach(s => skillSet.add(s.trim()));
        }
      });
      setSkills(['All', ...Array.from(skillSet)]);
    } catch (err) {
      console.error('Failed to fetch freelancers', err);
    }
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setSelectedSkill(value);
    if (value === 'All') {
      setFiltered(freelancers);
    } else {
      const filteredList = freelancers.filter(f => f.skills?.includes(value));
      setFiltered(filteredList);
    }
  };

  const handleFreelancerClick = async (id) => {
  try {
    const res = await fetch(`${API_URL}/api/admin/freelancers/${id}`);
    const data = await res.json();
    setSelectedFreelancer(data);

    if (data.cv && data.cv.data) {
      const base64CV = `data:${data.cv.contentType};base64,${btoa(
        new Uint8Array(data.cv.data.data).reduce((acc, byte) => acc + String.fromCharCode(byte), '')
      )}`;
      setCvPreviewUrl(base64CV);
    } else {
      setCvPreviewUrl(null);
    }

  } catch (err) {
    console.error('Error fetching freelancer details:', err);
  }
};







  return (
    <div>
      <h4 className="mb-3">Freelancers</h4>
      {!selectedFreelancer && (
        <>
          <Form.Group className="mb-4">
            <Form.Label>Filter by Skill</Form.Label>
            <Form.Select value={selectedSkill} onChange={handleFilterChange}>
              {skills.map((skill, idx) => (
                <option key={idx} value={skill}>{skill}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <ListGroup>
            {filtered.map(f => (
            //   <ListGroup.Item key={f._id} action onClick={() => setSelectedFreelancer(f)}>
            //     <div className="d-flex justify-content-between align-items-center">
            //       <div><strong>{f.first_name} {f.last_name}</strong></div>
            //       <div className="text-muted" style={{ fontSize: '0.9em' }}>
            //         {Array.isArray(f.skills) ? f.skills.slice(0, 3).join(', ') : f.skills}
            //       </div>
            //     </div>
            //   </ListGroup.Item>
                <ListGroup.Item key={f._id} action onClick={() => handleFreelancerClick(f._id)}>
                    <strong>{`${f.first_name} ${f.last_name}`}</strong>
                </ListGroup.Item>

            ))}
          </ListGroup>
        </>
      )}

      {selectedFreelancer && (
        <Card className="p-4 shadow-sm">
          <Button variant="link" onClick={() => setSelectedFreelancer(null)} className="mb-3 align-left">
            <ArrowLeft /> Back to List
          </Button>
          <h5>{`${selectedFreelancer.first_name} ${selectedFreelancer.last_name}`}</h5>
          <p><strong>Email:</strong> {selectedFreelancer.email}</p>
          <p><strong>Phone:</strong> {selectedFreelancer.phone}</p>
          <p><strong>Country:</strong> {selectedFreelancer.country}</p>
          <p><strong>Gender:</strong> {selectedFreelancer.gender}</p>
          {/* <p><strong>Skills:</strong> {Array.isArray(selectedFreelancer.skills) ? selectedFreelancer.skills.join(', ') : selectedFreelancer.skills}</p> */}
            <p><strong>Skills:</strong></p>
            <div className="d-flex gap-1 flex-wrap">
            {Array.isArray(selectedFreelancer.skills) && selectedFreelancer.skills.length > 0 ? (
                selectedFreelancer.skills.map((skill, idx) => (
                <span key={idx} className="badge bg-primary">{skill}</span>
                ))
            ) : (
                <span className="text-muted">No skills</span>
            )}
            </div>


          <p><strong>Qualifications:</strong></p>
          <ul>
            {(selectedFreelancer.qualification || []).map((q, i) => (
              <li key={i}>{q.course} from {q.university} ({q.year})</li>
            ))}
          </ul>

          <p><strong>Experiences:</strong></p>
          <ul>
            {(selectedFreelancer.experience || []).map((e, i) => (
              <li key={i}>{e.title} at {e.company} ({e.from} - {e.to})</li>
            ))}
          </ul>

          {cvPreviewUrl && (
            <div className="mt-3">
                <h6>CV Preview</h6>
                <embed src={cvPreviewUrl} type="application/pdf" width="100%" height="400px" />
            </div>
            )}
        </Card>
      )}
    </div>
  );
};

export default FreelancersTab;
